/* global axios */
import ApiClient from './ApiClient';

class RemoteSupportIdentitiesAPI extends ApiClient {
  constructor() {
    super('remote_support_identities', { accountScoped: true });
    this.contactId = null;
  }

  urlFor(contactId) {
    return `${this.baseUrl()}/contacts/${contactId}/remote_support_identities`;
  }

  get(contactId) {
    this.contactId = contactId;
    return axios.get(this.urlFor(contactId));
  }

  create(contactId, { rustdeskId, label, rustdeskPassword }) {
    this.contactId = contactId;
    return axios.post(this.urlFor(contactId), {
      remote_support_contact_identity: {
        rustdesk_id: rustdeskId,
        label,
        ...(rustdeskPassword ? { rustdesk_password: rustdeskPassword } : {}),
      },
    });
  }

  touch(contactId, identityId) {
    this.contactId = contactId;
    return axios.post(`${this.urlFor(contactId)}/${identityId}/touch`);
  }

  archive(contactId, identityId) {
    this.contactId = contactId;
    return axios.delete(`${this.urlFor(contactId)}/${identityId}`);
  }
}

export default new RemoteSupportIdentitiesAPI();
